/* eslint-disable react/no-danger */
import React from 'react';
import Icon, { iconTypes } from 'components/icon';

export default function blockDescriptionProblem(bemClasses, data) {
  if (!data) return null;

  return (
    <div {...bemClasses('blockDescription', 'problem')}>
      <div {...bemClasses('content')}>
        <span {...bemClasses('text')}>
          <Icon {...bemClasses('icon', 'info')} type={iconTypes.infoCircleBorder} />
          <span itemProp="description" dangerouslySetInnerHTML={{ __html: data }} />
        </span>
      </div>
    </div>
  );
}
